<section class="orders-page">
  <header class="orders-toolbar">
    <div>
      <h1>Заказы</h1>
      <span>Резервы, оплаты и состав проданных билетов.</span>
    </div>
  </header>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="orders-panel">
    <div class="panel-tools">
      <div class="status-tabs" aria-label="Фильтр по статусу заказа">
        <button type="button" [class.active]="statusFilter === ''" (click)="setStatusFilter('')">Все</button>
        <button type="button" [class.active]="statusFilter === 'reserved'" (click)="setStatusFilter('reserved')">Резерв</button>
        <button type="button" [class.active]="statusFilter === 'paid'" (click)="setStatusFilter('paid')">Оплачены</button>
        <button type="button" [class.active]="statusFilter === 'cancelled'" (click)="setStatusFilter('cancelled')">Отменены</button>
        <button type="button" [class.active]="statusFilter === 'expired'" (click)="setStatusFilter('expired')">Истекшие</button>
      </div>

      <a class="action-button panel-add-button" routerLink="/dashboard/orders/new">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
        <span>Добавить</span>
      </a>
    </div>

    <div class="table-wrap" *ngIf="pagedOrders.length > 0; else emptyState">
      <table class="orders-table">
        <thead>
          <tr>
            <th><button type="button" (click)="setSort('code')" [attr.aria-sort]="sortState('code')">Заказ</button></th>
            <th><button type="button" (click)="setSort('client')" [attr.aria-sort]="sortState('client')">Клиент</button></th>
            <th><button type="button" (click)="setSort('event')" [attr.aria-sort]="sortState('event')">Событие</button></th>
            <th><button type="button" (click)="setSort('tickets')" [attr.aria-sort]="sortState('tickets')">Билеты</button></th>
            <th><button type="button" (click)="setSort('total')" [attr.aria-sort]="sortState('total')">Сумма</button></th>
            <th><button type="button" (click)="setSort('reservation')" [attr.aria-sort]="sortState('reservation')">Резерв до</button></th>
            <th><button type="button" (click)="setSort('status')" [attr.aria-sort]="sortState('status')">Статус</button></th>
          </tr>
        </thead>
        <tbody>
          <tr class="order-row" *ngFor="let order of pagedOrders; trackBy: trackById" [routerLink]="['/dashboard/orders', getOrderRoute(order)]">
            <td><strong>{{ order.code }}</strong><small>{{ formatDate(order.createdAt) }}</small></td>
            <td>{{ order.client?.name || 'Клиент удален' }}</td>
            <td><strong>{{ order.event?.name || 'Событие удалено' }}</strong><small>{{ formatEventDate(order.event?.startsAt || null) }}</small></td>
            <td><span class="ticket-codes">{{ order.items.map(item => item.ticket?.code || '—').join(', ') }}</span></td>
            <td><strong>{{ formatMoney(order.total) }}</strong></td>
            <td>{{ order.status === 'reserved' ? formatDate(order.reservationExpiresAt) : '—' }}</td>
            <td><span class="status-pill" [class.reserved]="order.status === 'reserved'" [class.paid]="order.status === 'paid'" [class.cancelled]="order.status === 'cancelled' || order.status === 'expired'">{{ getStatusName(order.status) }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyState>
      <div class="empty-state">
        <h3>{{ loading ? 'Обновляем заказы...' : 'Заказов пока нет' }}</h3>
        <p *ngIf="!loading">Создайте резерв из доступных билетов выбранного события.</p>
        <a class="action-button primary" routerLink="/dashboard/orders/new" *ngIf="!loading">Добавить заказ</a>
      </div>
    </ng-template>

    <footer class="pagination-bar">
      <span>Страница {{ page }} из {{ totalPages }}</span>
      <label class="page-size-control">
        <span>Показывать</span>
        <select class="form-select" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let pageSizeOption of pageSizeOptions" [ngValue]="pageSizeOption">{{ pageSizeOption }}</option>
        </select>
      </label>
      <div class="pagination-actions">
        <button class="action-button ghost" type="button" [disabled]="page === 1" (click)="goToPage(page - 1)">Назад</button>
        <button class="action-button ghost" type="button" [disabled]="page === totalPages" (click)="goToPage(page + 1)">Вперед</button>
      </div>
    </footer>
  </section>
</section>
